module.exports = __webpack_public_path__ + "static/scale-model-of-national-museum-of-the-us-air-force-in-dayton-ohio-ee1f2193b05f39cb7b8e376611c2b6f6.png";